import { EVENT_VALIDATION_ERRORS } from '../../constants/ErrorConstants';
import { IEventValidationModel } from './IEventFormValidation';
import { InputElementModel } from '../services/InputElementModel';

const eventIdData: InputElementModel = {
  name: 'eventId',
  value: '',
  error: EVENT_VALIDATION_ERRORS.invalidEventId,
  expression: /^[A-Z0-9.-]+$/,
  isValid: true,
  isTouched: false
};
const eventNameData: InputElementModel = {
  name: 'eventName',
  value: '',
  error: EVENT_VALIDATION_ERRORS.invalidEventName,
  expression: /^[a-zA-Z]([a-zA-Z0-9-])*$/,
  isValid: true,
  isTouched: false
};

const categoryData: InputElementModel = {
  name: 'category',
  value: '',
  error: EVENT_VALIDATION_ERRORS.invalidCategory,
  expression: /^[a-zA-Z0-9-_\s(.+)]+$/,
  isValid: true,
  isTouched: false
};

const descriptiondata: InputElementModel = {
  name: 'description',
  value: '',
  error: EVENT_VALIDATION_ERRORS.invalidDescription,
  expression: /^[a-zA-Z0-9](.*)/,
  isValid: true,
  isTouched: false
};

const avroSchemaData: InputElementModel = {
  name: 'avroSchema',
  value: '',
  error: EVENT_VALIDATION_ERRORS.invalidAvroJson,
  isValid: true,
  isTouched: false
};

const versionData: InputElementModel = {
  name: 'version',
  value: '',
  error: EVENT_VALIDATION_ERRORS.invalidVersion,
  expression: /^[a-zA-Z0-9-_\s(.+)]+$/,
  isValid: true,
  isTouched: false
};

const eventTypeData: InputElementModel = {
  name: 'eventType',
  value: '',
  error: EVENT_VALIDATION_ERRORS.invalidCategory
};

const schemaNameData: InputElementModel = {
  name: 'schemaName',
  value: '',
  error: EVENT_VALIDATION_ERRORS.invalidSchemaName,
  expression: /^[a-zA-Z]([a-zA-Z0-9-._])*$/,
  isValid: true,
  isTouched: false
};

export class EventDetailsFormData implements IEventValidationModel {
  eventId: InputElementModel;

  eventName: InputElementModel;

  category: InputElementModel;

  description: InputElementModel;

  version: InputElementModel;

  eventType: InputElementModel;

  schemaName: InputElementModel;

  avroSchema: InputElementModel;

  constructor() {
    this.eventId = eventIdData;
    this.eventName = eventNameData;
    this.category = categoryData;
    this.description = descriptiondata;
    this.version = versionData;
    this.eventType = eventTypeData;
    this.schemaName = schemaNameData;
    this.avroSchema = avroSchemaData;
  }
}
